var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSuccessDisabledMotivation = function SvgIconSuccessDisabledMotivation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.6 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6,
    cy: 4,
    r: 3.5,
    stroke: "#E4E7EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2.934 3.909 1.171 1.172 2.162-2.162",
    stroke: "#E4E7EA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgIconSuccessDisabledMotivation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOSA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC42MDAwOTggNEMwLjYwMDA5OCAxLjc5MDg2IDIuMzkwOTYgMCA0LjYwMDEgMEM2LjgwOTI0IDAgOC42MDAxIDEuNzkwODYgOC42MDAxIDRDOC42MDAxIDYuMjA5MTQgNi44MDkyNCA4IDQuNjAwMSA4QzIuMzkwOTYgOCAwLjYwMDA5OCA2LjIwOTE0IDAuNjAwMDk4IDRaIiBmaWxsPSJ3aGl0ZSIvPgo8Y2lyY2xlIGN4PSI0LjYwMDEiIGN5PSI0IiByPSIzLjUiIHN0cm9rZT0iI0U0RTdFQSIvPgo8cGF0aCBkPSJNMi45MzM1OSAzLjkwOTA0TDQuMTA1MzYgNS4wODA4MUw2LjI2NjkzIDIuOTE5MTYiIHN0cm9rZT0iI0U0RTdFQSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";